// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZaiChatDesktopPage {
  height: calc(100vh - 60px);
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-chat-desktop-page/zai-chat-desktop-page.styles.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,WAAA;AACF","sourcesContent":[".ZaiChatDesktopPage {\n  height: calc(100vh - 60px);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
